
export const isMenuDescendant = (item, parent_id) => {
    if (!item || !parent_id) return false;
    if (item.id === parent_id) return true;
    return item.children.some(c => isMenuDescendant(c, parent_id));
};

export function getTextWidth(text, cssFont) {
    const context = (function() {
        if (!getTextWidth.ctxes) getTextWidth.ctxes = {};
        if (getTextWidth.ctxes[cssFont]) return getTextWidth.ctxes[cssFont];
        let ctx = document.createElement("canvas").getContext("2d");
        ctx.font = cssFont;
        getTextWidth.ctxes[cssFont] = ctx;
        return getTextWidth.ctxes[cssFont];
    })();
    return context.measureText(text).width;
}

